<template>
  <div style="height: 100%;">
<!--    <div class="test">-->
<!--      <button @click="$cacheService.deleteAllFiles">deleteAllFiles</button>-->
<!--    </div>-->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
  @import "./styles/variables";
  @import "./styles/fonts";
  @import "./styles/utils";

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    user-select: none;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter';
  }

  .test {
    position: absolute;
    top: 10%;
    left: 10%;
    min-height: 20vh;
    min-width: 20vw;

    padding: 1vh;

    background-color: #000000aa;

    border-radius: 1vh;

    color: white;

    z-index: 9999999999;
  }
</style>
